import { cloneDeep } from 'lodash';
import {
  deleteSelectedAgriProduct,
  loadSelectedAgriProduct,
  addAgriProduct,
  loadAgriProduct,
} from './../../../../utils/states-management/actions/agri-product.action';
import { PopoverComponent } from './../../../../widgets/popover/popover.component';
import { CAFE_IDS, MORPH_Product } from './../../../../utils/consts';
import { UnifiedCashflowInputComponentComponent } from 'src/app/modules/cashflow/unified-cashflow-input-component/unified-cashflow-input-component.component';
import { RoutingConfig } from 'src/app/utils/routing-config';
import {
  PRODUCT_MORPHABLE,
  CAFE_ACCOUNTING_ENTRY_CATEGORY,
} from 'src/app/utils/consts';
import { ToastUtils } from 'src/app/utils/toast_builder';
import { OTROS_ACCOUNTING_ENTRY_CATEGORY } from '../../../../utils/consts';
import { Component, Input, OnInit } from '@angular/core';
import { Preferences } from '@capacitor/preferences';
import { dev } from '../../../../config/offlines_keys.json';
import { Router } from '@angular/router';
import {
  IonNav,
  LoadingController,
  ModalController,
  PopoverController,
} from '@ionic/angular';
import routes from '../../../../config/routing.json';
import { PriorDashboardComponent } from '../../../prior-dashboard/prior-dashboard.component';
import { ProductFormComponent } from '../product-form/product-form.component';
import { ProductionSalesOtherComponent } from '../../../home/cashflow/production-sales-other/production-sales-other.component';
import { showConfirmModal } from 'src/app/utils/pop_over_maker';
import { UserInfo } from 'src/app/apis/users-info.service';
import { Good } from 'src/app/models/good.model';
import { ProductionAPI } from 'src/app/apis/FarmAPI/productions.service';
import { ProductionsPerfarm } from 'src/app/models/farm/production_per_farm';
import { TranslateService } from '@ngx-translate/core';
import { environment } from 'src/environments/environment';
import { GoodsAPI } from 'src/app/apis/goods.service';
import { map, switchMap, take } from 'rxjs/operators';
import { HttpErrorResponse } from '@angular/common/http';
import { Store } from '@ngrx/store';
import { getFarm } from 'src/app/utils/states-management/selector/farm-selector';
import { lastValueFrom } from 'rxjs';
import { OtrosDisplayableListItem } from 'src/app/models/cash-flow/otros_displayable_list_item';
import Owner from 'src/app/models/owner.model';
import { connectionStatus } from 'src/app/utils/states-management/reducers/offline.reducer';

interface CoffeProduct {
  is_cafe: boolean;
  name: string;
  products: Array<any>;
}

@Component({
  selector: 'app-pre-product-selector',
  templateUrl: './pre-product-selector.component.html',
  styleUrls: ['./pre-product-selector.component.scss'],
})
export class PreProductSelectorComponent implements OnInit {
  modal;
  productList: ProductionsPerfarm[] = new Array();
  coffe_title = 'Café';
  @Input() nav: IonNav;
  @Input() rootStack;
  isDashboardView: Boolean;
  is_coffe_mapped = false;
  loadingModal;
  coffeProduct: CoffeProduct = {
    is_cafe: true,
    name: this.coffe_title,
    products: new Array(),
  };
  selected_langage;
  base_url = 'assets';
  formConfig;
  cropProducts;
  cropConfig;
  is_loading: boolean = false;
  update_at;
  isProcessing: boolean = false;

  constructor(
    private router: Router,
    private modalController: ModalController,
    private popoverController: PopoverController,
    private userInfo: UserInfo,
    public translateService: TranslateService,
    private loadingController: LoadingController,
    private productionAPI: ProductionAPI,
    private toastUtils: ToastUtils,
    private goodsAPi: GoodsAPI,
    private routingConfig: RoutingConfig,
    private store: Store<{
      otrosCategories: Array<OtrosDisplayableListItem>;
      agriculturalProduct: any;
      owner: Owner;
    }>
  ) { }
  allProduct: ProductionsPerfarm[] = new Array();
  title = ""
  async ngOnInit() {
    this.cropConfig = await this.routingConfig.getCropFormConfig();
    this.loadingModal = await this.loadingController.create();
    this.isDashboardView = this.router.url.includes(routes.dashboard.home);

    this.store.select('owner').subscribe(async (value: any) => {
      let owner = cloneDeep(value);
      let config = await lastValueFrom(await this.routingConfig.getPageFormConfig('PreProductSelectorComponent'))
      let labels_keys = config?.labels_keys;
      this.title = labels_keys[JSON.parse(owner.profile_info)?.role]
    });
    await this.translate();
    await this.fetchProductionsPerFarm();

    this.store.select('agriculturalProduct').subscribe(async (value) => {
      this.productList = cloneDeep(value.selectedProducts);

      this.getLastUpdate(this.productList);
    });

    this.cropProducts = JSON.parse(
      (await Preferences.get({ key: dev.CROP_PRODUCT }))?.value
    );
    this.showPopOver('infobull.infobull_agriculture_product');
    this.store.select(connectionStatus).subscribe((val: boolean) => {
      this.isOnline = val;
    });


  }
  isOnline: boolean = true

  findCropAndRegroupProducts(selectedProducts) {
    let regroupedProducts = [];
    let productMap = new Map();

    selectedProducts.forEach((product) => {
      if (product?.morphable?.product_id) {
        const productId = product?.morphable?.product_id;
        if (!productMap.has(productId)) {
          let parentProduct = product?.morphable?.parent_product;
          parentProduct['goods'] = [product];
          parentProduct['morphable'] = product;
          parentProduct.morphable.product_id = product?.morphable?.product_id;
          productMap.set(productId, parentProduct);
        } else {
          productMap.get(productId)?.goods.push(product);
        }
      } else {
        regroupedProducts?.push(product);
      }
    });

    // Convert the map to an array for final output
    regroupedProducts = [
      ...regroupedProducts,
      ...Array.from(productMap.values()),
    ];
    return regroupedProducts;
  }

  async translate() {
    if (this.selected_langage == 'es') {
      this.coffe_title = 'Café';
    } else {
      this.coffe_title = 'Coffee';
    }
  }

  async fetchProductionsPerFarm() {
    this.store.dispatch(loadAgriProduct());
    this.store.dispatch(loadSelectedAgriProduct());
  }

  getLastUpdate(products) {
    if (products.length > 0) {
      var maxDate = new Date(
        Math.max(
          ...products.map((element) => {
            return new Date(element.created_at);
          })
        )
      );
      var minDate = new Date(
        Math.min(
          ...products.map((element) => {
            return new Date(element.created_at);
          })
        )
      );

      if (minDate?.getHours() + 1 < maxDate?.getHours()) {
        this.update_at = '';
      } else {
        this.update_at = maxDate;
      }
    }
  }
  async getCashflowRequestConfirmation(msg): Promise<Boolean> {
    if (!msg)
      msg = await this.translateService
        .get('add_cashflow')
        .toPromise()
        .then((value) => value);
    const modal = await showConfirmModal(
      this.popoverController,
      msg,
      null,
      'Sí',
      'No'
    );
    const { data } = await modal.onWillDismiss();
    return data?.confirmed;
  }

  async previous() {
    this.router.navigateByUrl(await this.routingConfig.getBackUrl());
  }

  async next() {
    this.router.navigateByUrl(await this.routingConfig.getNextUrl());
  }

  async add_production() {
    this.isProcessing = true;

    let componentProps = {
      modalController: this.modalController,
      categorie_id: 1,
      products: this.productList,
      is_preproduct_view: true,
      title: await this.translateService.instant(
        'label.add_production_agricola_farm'
      ),
    };
    let modal = await this.toastUtils.modalBuilder(
      ProductFormComponent,
      componentProps,
      ['my-custom-modal-css', 'modal-wrapper']
    );

    const { data } = await modal.onWillDismiss();
    this.isProcessing = false;

    // if (Array.isArray(data?.products) && data?.products.length > 0) {
    //   await this.saveProductions(data.products);
    // }
  }
  async showPopOver(message) {
    let componentProps = {
      key1: await this.translateService
        .get(message)
        .toPromise()
        .then((value) => value),
    };

    await this.toastUtils.popOverBuilder(
      componentProps,
      PopoverComponent,
      'popover-custom'
    );
  }


  navBack() {
    this.nav.setRoot(this.rootStack, {
      nav: this.nav,
      rootStack: PriorDashboardComponent,
    });
  }
  async requestUserToInsertCashflow(msg, item) {
    const modal = await showConfirmModal(
      this.popoverController,
      msg,
      null,
      await this.translateService
        .get('yes')
        .toPromise()
        .then((value) => value),

      await this.translateService
        .get('no')
        .toPromise()
        .then((value) => value)
    );
    const { data } = await modal.onWillDismiss();
    if (data?.confirmed) {
      await this.showOtorosInputComponent(item);
      await this.fetchProductionsPerFarm();
    }
    return data?.confirmed;
  }

  async sortArray() {
    this.productList.forEach((product, index) => {
      if (product.comment) {
        product.morphable.name = product.comment;
        product.morphable.name_en = product.comment;
      }
    });

    if (this.selected_langage === 'es')
      this.productList.sort((a, b) => {
        if (
          a.morphable.name?.normalize('NFD').toLowerCase() >
          b.morphable.name?.normalize('NFD').toLowerCase()
        ) {
          return 1;
        }
        if (
          a.morphable.name?.normalize('NFD').toLowerCase() <
          b.morphable.name?.normalize('NFD').toLowerCase()
        ) {
          return -1;
        }
        return 0;
      });
    else
      this.productList.sort((a, b) => {
        if (
          a.morphable['name_' + this.selected_langage]
            ?.normalize('NFD')
            .toLowerCase() >
          b.morphable['name_' + this.selected_langage]
            ?.normalize('NFD')
            .toLowerCase()
        ) {
          return 1;
        }
        if (
          a.morphable['name_' + this.selected_langage]
            ?.normalize('NFD')
            .toLowerCase() <
          b.morphable['name_' + this.selected_langage]
            ?.normalize('NFD')
            .toLowerCase()
        ) {
          return -1;
        }
        return 0;
      });
  }

  details(item) {
    this.nav.setRoot(ProductionSalesOtherComponent, {
      product: item,
      nav: this.nav,
    });
  }

  async showOtorosInputComponent(products: ProductionsPerfarm) {
    const cashFlowCategFiltred = JSON.parse(
      (
        await Preferences.get({
          key: dev.CASHFLOW_CATEGORIES,
        })
      ).value
    );

    const comp = UnifiedCashflowInputComponentComponent;
    let componentProps = {
      accountingEntryCategories: CAFE_IDS.includes(products.morphable_id)
        ? cashFlowCategFiltred.find(
          (value) => value.id === CAFE_ACCOUNTING_ENTRY_CATEGORY
        )
        : cashFlowCategFiltred.find(
          (value) => value.id === OTROS_ACCOUNTING_ENTRY_CATEGORY
        ),
    };
    let modal = await this.toastUtils.modalBuilder(
      comp,
      componentProps,
      ['my-custom-modal-css', 'modal-wrapper'],
      true,
      '1'
    );

    await modal.onWillDismiss();
  }

  async deletePressed(object) {
    let productionToDelete = [];
    if (object?.is_crop) {

      this.productList.forEach((production) => {
        if (
          production?.morphable?.product_id == object?.morphable?.product_id
        ) {
          let farmProduction: ProductionsPerfarm = production;

          productionToDelete.push(farmProduction);
        }
      });
    } else {
      let farmProduction: ProductionsPerfarm = object;
      productionToDelete = [farmProduction];
    }
    // Handle offline mode
    if (!this.isOnline) {
      this.store.dispatch(deleteSelectedAgriProduct({ products: productionToDelete }));
      return;
    }

    try {
      // Get translations in parallel for better performance
      const [msg, confirmButton, cancelButton] = await Promise.all([
        this.translateService.instant('label.delete_product'),
        this.translateService.instant('confirm'),
        this.translateService.instant('cancel')
      ]);

      // Show confirmation modal
      const modal = await showConfirmModal(
        this.popoverController,
        msg,
        null,
        confirmButton,
        cancelButton
      );
      const { data } = await modal.onWillDismiss();

      if (data?.confirmed) {
        this.store.dispatch(deleteSelectedAgriProduct({ products: productionToDelete }));
      }
    } catch (error) {
      console.error('Error during agricultural product deletion:', error);
      // Optionally, display an error message to the user
      // await this.toastUtils.popOverBuilder(await this.translateService.instant('error.delete_failed'));
    }
  }
}
